import FileExample from "../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/file";
import RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHfile from "!!raw-loader!../../../../../../packages/pragmatic-drag-and-drop/documentation/examples/file";
import * as React from 'react';
export default {
  FileExample,
  RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHfile,
  React
};